<template>
  <div class="notifications top-right">
    <transition-group name="notifications" tag="p">
      <div
        class="notification"
        v-for="(notification, index) in $store.getters.notifications"
        :key="index"
        @mousemove="() => onNotificationHover(index)"
        @click="() => onNotificationClicked(notification)"
      >
        <div class="left">
          <div class="title">{{ notification.title }}</div>
          <div class="subtitle">{{ notification.subtitle }}</div>
        </div>
        <div class="right">
          <div class="content">{{ notification.content }}</div>
          <div class="icon">
            <img v-if="notification.imageUrl" :src="notification.imageUrl" />
          </div>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import {
  POP_NOTIFICATION,
  UPDATE_NOTIFICATION_VISIBILITY,
} from "../store/actions";
export default {
  components: {},
  methods: {
    onNotificationHover(index) {
      this.$store.dispatch(UPDATE_NOTIFICATION_VISIBILITY, index);
    },
    onNotificationClicked(notification) {
      this.$store.dispatch(POP_NOTIFICATION, notification);
    },
  },
  props: {},
};
</script>

<style lang="scss" scoped>
.top-right {
  top: 20px;
  right: 20px;
}
.notifications {
  position: fixed;
  z-index: 200;
  .notification {
    width: 375px;
    border-radius: 4px;
    min-height: 53px;
    padding: 10px;
    background: $background-color;
    margin-bottom: 20px;
    border: 1px solid $grey;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    .left {
      .title {
        @include f-button;
        color: $light-black;
      }

      .subtitle {
        @include f-small;
        color: $light-black;
      }
    }
    .right {
      display: flex;
      .content {
        @include f-button;
        color: $light-black;
        display: flex;
        align-items: center;
        margin-right: 7px;
      }
      .icon {
        width: 33px;
        height: 33px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: $black-grey;
        img {
          max-width: 100%;
          max-height: 100%;
        }
      }
    }
  }
}
.notifications-enter-active {
  transition: all 0.4s ease-in-out;
}

.notifications-leave-active {
  transition: all 0.4s ease-in-out;
}

.notifications-enter-from,
.notifications-leave-to {
  opacity: 0.4s;
  transform: translateY(-30px);
}
</style>